import { gql } from '@apollo/client';
import BASE_ORGANIZATION_ROLE_FRAGMENT from 'graph/fragments/organization-role';
import BASE_USER_FRAGMENT from 'graph/fragments/user';
import BASE_USER_LICENSE_USAGE from 'graph/fragments/user-license-usage';
import BASE_USER_SETTING_FRAGMENT from 'graph/fragments/user-setting';

const GET_ME = gql`
  query getMe {
    me {
      ...BaseUser
      classroomPrivileges {
        classroomId
        privileges
      }
      licenseUsage {
        ...BaseUserLicenseUsage
      }
      organizationAssociations {
        organizationId
        organization {
          id
          externalId {
            sourceKind
            sourceId
          }
          name
          parentOrganization {
            id
          }
          licenseUsage {
            totalCount
            product {
              family {
                code
              }
            }
          }
        }
        organizationRoles {
          ...BaseOrganizationRole
        }
      }
      organizationPrivileges {
        organizationId
        privileges
      }
      settings {
        ...BaseUserSetting
      }
    }
  }
  ${BASE_ORGANIZATION_ROLE_FRAGMENT}
  ${BASE_USER_FRAGMENT}
  ${BASE_USER_LICENSE_USAGE}
  ${BASE_USER_SETTING_FRAGMENT}
`;

export default GET_ME;
